<template>
  <el-row>
    <el-col :sm="24" :md="{span: 8, offset: 8}">
      <div class="container-fluid" style="padding-top:20px;">
        <el-alert message="Gửi thành công" description="Cảm ơn bạn đã gửi thông tin cho chúng tôi" type="success" show-icon>
        </el-alert>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  async created() {},
  methods: {}
}
</script>
